import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { 
  CalendarIcon, 
  WalletIcon, 
  ArrowRightIcon,
  EthereumIcon,
  MaticIcon,
  OptimismIcon,
  PolygonIcon,
  SolanaIcon,
  TezosIcon,
  ArbitrumIcon,
  BaseIcon
} from '../../icons'

type OffChainSaleProps = {
  metadata: {
    properties: {
      date?: string;
      ownerAddress?: string;
      receiverAddress?: string;
      amount?: string;
      currency?: string;
			description?: string;
    };
  };
}

export default function OffChainSale({ metadata }: OffChainSaleProps) {
  const { properties } = metadata;

  const truncateAddress = (address: string) => {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  const getCurrencyIcon = (currency: string | undefined) => {
    if (!currency) return null;
    
    const currencyUpper = currency.toUpperCase();
    switch (currencyUpper) {
      case 'ETH':
        return <EthereumIcon size="small" />;
      case 'MATIC':
        return <MaticIcon size="small" />;
      case 'OP':
      case 'OPTIMISM':
        return <OptimismIcon size="small" />;
      case 'POLYGON':
        return <PolygonIcon size="small" />;
      case 'SOL':
      case 'SOLANA':
        return <SolanaIcon size="small" />;
      case 'XTZ':
      case 'TEZOS':
        return <TezosIcon size="small" />;
      case 'ARB':
      case 'ARBITRUM':
        return <ArbitrumIcon size="small" />;
      case 'BASE':
        return <BaseIcon size="small" />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col space-y-2">
      {/* Transaction Amount Header */}
      <div className="flex items-center space-x-2 text-textPrimaryLight dark:text-textPrimaryDark">
        <TypographyHeader size="small">
          {properties.amount} {properties.currency?.toUpperCase()}
        </TypographyHeader>
      </div>

      {/* Date */}
      {properties.date && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <CalendarIcon size="small" />
          <TypographyLabel size="small">
            {new Date(properties.date).toLocaleDateString()}
          </TypographyLabel>
        </div>
      )}

      {/* Transaction Parties */}
      <div className="flex items-center justify-between text-textSecondaryLight dark:text-textSecondaryDark">
        <div className="flex items-center space-x-2">
          <WalletIcon size="small" />
          <TypographyLabel size="small">
            {truncateAddress(properties.ownerAddress || '')}
          </TypographyLabel>
        </div>
        <ArrowRightIcon size="small" />
        <div className="flex items-center space-x-2">
          <WalletIcon size="small" />
          <TypographyLabel size="small">
            {truncateAddress(properties.receiverAddress || '')}
          </TypographyLabel>
        </div>
      </div>

      {/* Transaction Value */}
      <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
        {getCurrencyIcon(properties.currency)}
        <TypographyLabel size="small">
          {properties.amount} {properties.currency?.toUpperCase()}
        </TypographyLabel>
      </div>

			{/* description */}
			{properties.description && (
				<TypographyParagraph size="small" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark">
					{properties.description}
				</TypographyParagraph>
			)}
    </div>
  );
} 